import { useEffect, useRef, useState } from 'react';
import { useOpenLayersContext } from '../OpenLayersContext';
import { MapBrowserEvent } from 'ol';
import { Coordinate } from 'ol/coordinate';

export function useCursorStationary(triggerTime = 100): Coordinate | null {
  const cursorPosition = useRef<Coordinate | null>(null);
  const lastCursorPosition = useRef<Coordinate | null>(null);
  const [stationaryPosition, setStationaryPosition] =
    useState<Coordinate | null>(null);
  const wasStationary = useRef(false);

  const context = useOpenLayersContext();

  useEffect(() => {
    const onMouseMove = (e: MapBrowserEvent<UIEvent>) => {
      cursorPosition.current = e.coordinate;
      wasStationary.current = false;
    };

    context.map.on('pointermove', onMouseMove);

    return () => {
      context.map.un('pointermove', onMouseMove);
    };
  }, [context]);

  useEffect(() => {
    const checkCursorStationary = setInterval(() => {
      if (cursorPosition.current && lastCursorPosition.current) {
        const [lng, lat] = cursorPosition.current;
        const [lastLng, lastLat] = lastCursorPosition.current;

        const isStationary = lat === lastLat && lng === lastLng;
        if (isStationary && !wasStationary.current) {
          setStationaryPosition(cursorPosition.current);
        }
        wasStationary.current = isStationary;
      }
      lastCursorPosition.current = cursorPosition.current;
    }, triggerTime);
    return () => {
      clearInterval(checkCursorStationary);
    };
  }, [triggerTime]);

  return stationaryPosition;
}
